function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React from 'react';
import { cx } from '@emotion/css';
import { createSwitchStyle, prefix, checked as checkedClass, forbidden, hover, slider, children as childrenCss, loading as loadingCss, loadingStyle } from "./index.style";
import useThemeProps from "../../hooks/useThemeProps";
import { isBoolean, isUndefined, typeOf, validVariable } from "../../utils";
import { useOnUpdate } from "../../hooks/useOnUpdate";

var InternalSwitch = function InternalSwitch(props, ref) {
  var theme = useThemeProps();
  var formattedProps = {};
  var INNER_CHECKED = isUndefined(props.checked); // format

  if (INNER_CHECKED) {
    // 非受控
    Object.assign(formattedProps, props, {
      checked: props.defaultChecked
    });
  } else {
    // 受控
    // eslint-disable-next-line no-lone-blocks
    {
      validVariable(isBoolean(props.checked), prefix(), "checked should be a boolean, but got ".concat(typeOf(props.checked)));
    }
    Object.assign(formattedProps, props);
  }

  var _React$useState = React.useState(Boolean(formattedProps.checked)),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      checked = _React$useState2[0],
      setChecked = _React$useState2[1];

  var switchStyle = React.useMemo(function () {
    return createSwitchStyle(theme);
  }, [theme]);
  var IS_USE_LOADING = !isUndefined(formattedProps.loading); // eslint-disable-next-line no-lone-blocks

  {
    if (IS_USE_LOADING) {
      validVariable(isBoolean(formattedProps.loading), prefix(), "loading should be a boolean, but got ".concat(typeOf(props.loading)));
    }
  }
  var isLoading = IS_USE_LOADING ? formattedProps.loading : false;
  var sizeClass = prefix("-".concat(formattedProps.size));

  var switchHandler = function switchHandler(event) {
    if (formattedProps.disabled || isLoading) {
      event.preventDefault();
      return;
    }

    var newChecked = !checked;

    if (INNER_CHECKED && !IS_USE_LOADING) {
      setChecked(newChecked);
    }

    if (formattedProps.onChange) {
      formattedProps.onChange(newChecked, event);
    }
  }; // loading, checked


  useOnUpdate(function () {
    if (!isLoading) {
      if (INNER_CHECKED) {
        setChecked(function (val) {
          return !val;
        });
      } else {
        setChecked(Boolean(props.checked));
      }
    }
  }, [props.checked, isLoading, INNER_CHECKED]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    onClick: switchHandler,
    style: props.style,
    className: cx(switchStyle, IS_USE_LOADING ? loadingStyle : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: sizeClass()
  }, /*#__PURE__*/React.createElement("div", {
    onTransitionEnd: function onTransitionEnd(e) {
      return e.stopPropagation();
    },
    className: cx(prefix(), sizeClass(), checked ? checkedClass() : '', formattedProps.disabled ? forbidden() : hover(), formattedProps.loading ? loadingCss() : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: slider()
  }, IS_USE_LOADING && /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "50",
    cy: "50",
    r: "45",
    pathLength: "1"
  }))))), props.children && /*#__PURE__*/React.createElement("div", {
    className: childrenCss()
  }, props.children));
};

var Switch = /*#__PURE__*/React.forwardRef(InternalSwitch);
Switch.displayName = 'Switch';
Switch.defaultProps = {
  defaultChecked: false,
  disabled: false,
  size: 'small'
};
export default /*#__PURE__*/React.memo(Switch);